import { combineReducers } from "redux";
import {
  GET_MESSAGE_DT,
  GET_MESSAGE_DT_OK,
  GET_MESSAGE_DT_ERR,
  DO_MESSAGE_DT_CLEANUP,
  CREATE_MESSAGE,
  CREATE_MESSAGE_OK,
  CREATE_MESSAGE_ERR,
} from "./actionTypes";

const defaultDtState = {
  messages: [],
  totalCount: 0,
  listParams: {
    sortBy: 'id',
    sortDir: 'desc',
    pageSize: 100, // we will keep a fixed pageSize at the moment as getting the totalCount can be too expensive
    page: 1,
  },
  messagesError: null,
  isLoadInProgress: false,
  saved: null,
  isSaveInProgress: false,
  saveError: null,
}

const Dt = (state = defaultDtState, action) => {
  switch (action.type) {
    case GET_MESSAGE_DT:
      state = {
        ...state,
        listParams: action.payload.params,
        isLoadInProgress: true,
        messagesError: null,
      };
      break
    case GET_MESSAGE_DT_OK:
      state = {
        ...state,
        isLoadInProgress: false,
        messages: action.payload.response.messages,
        totalCount: action.payload.response.totalCount,
      }
      break
    case GET_MESSAGE_DT_ERR:
      state = {
        ...state,
        isLoadInProgress: false,
        messagesError: action.payload.error,
        messages: [],
        totalCount: 0,
      }
      break
    case DO_MESSAGE_DT_CLEANUP:
      state = { ...defaultDtState }
      break
    case CREATE_MESSAGE:
      state = {
        ...state,
        isSaveInProgress: true,
        saveError: null,
        saved: null,
      }
      break
    case CREATE_MESSAGE_OK:
      state = {
        ...state,
        isSaveInProgress: false,
        saved: true
      }
      break
    case CREATE_MESSAGE_ERR:
      state = {
        ...state,
        isSaveInProgress: false,
        saved: false,
        saveError: action.payload.error
      }
      break
  }
  return state;
}

export default combineReducers({
  Dt,
});